import * as a2aTransfersActions from './a2aTransfersActions';
import a2aTransfersReducer from './a2aTransfersReducer';
import a2aTransfersSagas from './a2aTransfersSagas';
import * as a2aTransfersSelectors from './a2aTransfersSelectors';
import * as a2aTransfersTypes from './a2aTransfersTypes';
import * as a2aTransfersUtils from './a2aTransfersUtils';

const { A2A_TRANSFERS_REDUCER_KEY } = a2aTransfersTypes;

const A2A_TRANSFERS_VERSION_NUMBER = 1;

export {
  A2A_TRANSFERS_VERSION_NUMBER,
  A2A_TRANSFERS_REDUCER_KEY,
  a2aTransfersActions,
  a2aTransfersReducer,
  a2aTransfersSagas,
  a2aTransfersSelectors,
  a2aTransfersTypes,
  a2aTransfersUtils,
};
